import styled from "styled-components";
import Slider from "common/Slider/StyledSlider";
import { FilterSectionData } from "@shared/features/filters/types";
import Flex from "common/Boxes/Flex";
import CustomInputNumber from "common/Inputs/CustomInputNumber";
import { isNumber } from "lodash";
import { FilterType, SliderFilterType } from "@shared/types";
import { useDebouncedValue } from "@shared/utils/hooks/useDebouncedValue";

const SliderFiltersSection = ({
  filterType,
  value,
  options,
  onChange,
}: FilterSectionData<SliderFilterType>) => {
  const [debouncedValue, debouncedOnChange] = useDebouncedValue(
    value,
    onChange
  );
  const suffix = filterType === FilterType.LEVERAGE ? "x" : "";
  const onInputChange = (inputValue: number | undefined, isMin: boolean) => {
    let parsedValue = inputValue;
    const updatedValue: [number | undefined, number | undefined] = isMin
      ? [parsedValue, debouncedValue?.[1]]
      : [debouncedValue?.[0], parsedValue];
    debouncedOnChange(updatedValue);
  };

  return (
    <div>
      <StyledSlider
        step={1}
        min={isNumber(options?.[0]) ? options?.[0] : undefined}
        max={isNumber(options?.[1]) ? options?.[1] : undefined}
        range={true}
        value={debouncedValue}
        tooltip={{ open: false }}
        onChange={debouncedOnChange}
      />
      <Flex style={{ marginTop: 4 }}>
        {/*@ts-ignore*/}
        <StyledInput
          bordered={true}
          value={debouncedValue?.[0]}
          onChange={(val: number) => onInputChange(val, true)}
          stringMode={false}
          suffix={suffix}
        />
        {/*@ts-ignore*/}
        <StyledInput
          bordered={true}
          value={debouncedValue?.[1]}
          onChange={(val: number) => onInputChange(val, false)}
          stringMode={false}
          suffix={suffix}
        />
      </Flex>
    </div>
  );
};

export default SliderFiltersSection;

const StyledSlider = styled(Slider)`
  margin: 20px 12px 0;
  height: 20px;
  .ant-slider-mark-text:last-of-type {
    left: 95% !important;
`;
const StyledInput = styled(CustomInputNumber)`
  width: 55px !important;
  padding: 4px 8px !important;
`;
